
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[siteHandle]/podcasts",
      function () {
        return require("private-next-pages/[siteHandle]/podcasts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[siteHandle]/podcasts"])
      });
    }
  